export const mutations = {
  STORE_TRUCK_DOCUMENTS(state, truckdocuments) {
    state.truckdocuments = truckdocuments;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/truckdocuments/mutations.js